module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card', {
    staticClass: "setup-container"
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Setup, when you initially need to setup voice + string authentication")])]), _vm._v(" "), _c('record-button', {
    on: {
      "recorded": _vm.onRecorded
    }
  }), _vm._v(" "), (_vm.connected) ? _c('div', [_vm._v(" " + _vm._s(_vm.training.count) + " / 5 ")]) : _vm._e(), _vm._v(" "), (_vm.connected) ? _c('md-button', {
    staticClass: "md-raised"
  }, [_vm._v("Status: " + _vm._s(_vm.training.state))]) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Your name")]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "placeholder": "Your name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        _vm.name = $event
      }
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("What's your numbah?")]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "input": function($event) {
        _vm.phoneNumber = _vm._n($event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("What's your emergency contact numbah?")]), _vm._v(" "), _c('md-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emergencyNumber),
      expression: "emergencyNumber"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.emergencyNumber)
    },
    on: {
      "input": function($event) {
        _vm.emergencyNumber = _vm._n($event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "disabled": !_vm.allowNext
    }
  }, [_vm._v("Next")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5409f025!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setup.vue
// module id = 102
// module chunks = 2